<template>
    <a href="javascript:void(0)" @click="sorting(sortBy)" class="color-black">
        <span v-html="lable">{{ lable }}</span>

        <template
            v-if="listConfig.sortBy == sortBy && listConfig.order == 'DESC'"
        >
            <img
                alt="icon"
                src="/maincss/images/product/down-arrow.svg"
                class="down-arrow"
                style="margin-left: 2px"
            />
        </template>
        <template
            v-else-if="listConfig.sortBy == sortBy && listConfig.order == 'ASC'"
        >
            <img
                alt="icon"
                src="/maincss/images/product/up-arrow.svg"
                class="up-arrow"
            />
        </template>
        <template v-else>
            <img
                alt="icon"
                src="/maincss/images/product/up-arrow.svg"
                class="up-arrow"
            />
            <img
                alt="icon"
                src="/maincss/images/product/down-arrow.svg"
                class="down-arrow"
            />
        </template>
    </a>
</template>
<script>
export default {
    /* eslint-disable */
    name: "Pagination",
    /* eslint-enable */
    props: {
        listConfig: {
            //   type: Array,
            required: true
        },
        sortBy: {
            type: String,
            required: true
        },
        lable: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            //   selected_page:1
        };
    },

    methods: {
        sorting(column) {
            /* eslint-disable */
            if (this.listConfig.sortBy != this.sortBy) {
                this.listConfig.sortBy = column;
                this.listConfig.order = "DESC";
            } else {
                this.listConfig.sortBy = column;
                if (this.listConfig.order == "DESC") {
                    this.listConfig.order = "ASC";
                } else if (this.listConfig.order == "ASC") {
                    this.listConfig.order = "";
                    this.listConfig.sortBy = "";
                } else {
                    this.listConfig.order = "DESC";
                }
            }
            /* eslint-enable */
            this.$emit("sorting", this.listConfig);
        }
    }
};
</script>
